import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  'pt-BR': {
    translation: {
      nav: {
        dashboard: 'Painel',
        ledger: 'Lançamento',
        statement: 'Extrato',
        reports: 'Relatórios',
        admin: 'Administração',
        signOut: 'Sair'
      },

      dashboard: {
        title: 'Painel',
        subtitle: 'Gerenciar Lançamentos semanais da tesouraria',
        newWeek: 'Nova Semana',
        totalLedgers: 'Total de Registros',
        totalAmount: 'Valor Total',
        averagePerWeek: 'Média Semanal',
        searchPlaceholder: 'Buscar por data, usuário ou notas...',
        loading: 'Carregando registros...',
        noLedgers: 'Nenhum registro encontrado',
        noLedgersSubtext: 'Crie seu primeiro Lançamento semanal para começar',
        netTotal: 'Total Líquido',
        edit: 'Editar',
        delete: 'Excluir',
        income: 'Receita',
        expense: 'Despesa',
        totalIncome: 'Receita Total',
        totalExpenses: 'Despesas Totais',
        recentActivity: 'Atividade Recente',
        last30DaysAvg: 'Média dos Últimos 30 Dias',
        balance: 'Balanço',
        saldo: 'Saldo',
        tithe: 'Dízimo',
        sabbathSchool: 'Escola Sabatina',
        fund: 'Caixa',
        expenses: 'Despesas',
        incomeSources: 'Fontes de Receita',
        expenseSources: 'Fontes de Despesas',
        noIncome: 'Nenhuma receita registrada',
        noExpenses: 'Nenhuma despesa registrada'
      },

      statement: {
        title: 'Extrato',
        subtitle: 'Visualizar extrato financeiro com filtros de data',
        currentBalance: 'Saldo Atual',
        incomeSources: 'Fontes de Receita',
        expenseItems: 'Despesas',
        totalChurch: 'Total Igreja',
        lessTithe: 'Menos: Dízimo',
        lessSabbathSchool: 'Menos: Escola Sabatina',
        startingBalance: 'Saldo Inicial',
        noIncome: 'Nenhuma receita registrada',
        noExpenses: 'Nenhuma despesa registrada',
        dateRange: 'Intervalo de Datas',
        startDate: 'Data Inicial',
        endDate: 'Data Final',
        allTime: 'Todo o Período',
        thisMonth: 'Este Mês',
        lastMonth: 'Mês Passado',
        thisYear: 'Este Ano',
        lastYear: 'Ano Passado',
        showing: 'Mostrando',
        to: 'até',
        applyFilter: 'Aplicar Filtro',
        clearFilter: 'Limpar Filtro'
      },

      reports: {
        title: 'Relatórios',
        subtitle: 'Visualizar e exportar relatórios da tesouraria',
        weeklySummary: 'Resumo Semanal',
        monthlySummary: 'Resumo Mensal',
        yearToDate: 'Ano até a Data',
        entryComparison: 'Comparação de Entradas',
        userActivity: 'Atividade do Usuário',
        startDate: 'Data Inicial',
        endDate: 'Data Final',
        exportCSV: 'Exportar CSV',
        exportPDF: 'Exportar PDF',
        loading: 'Carregando dados do relatório...',
        noData: 'Nenhum dado disponível para o intervalo de datas selecionado',
        date: 'Data',
        user: 'Usuário',
        total: 'Total',
        month: 'Mês',
        period: 'Período',
        entryType: 'Tipo de Entrada',
        count: 'Contagem',
        average: 'Média',
        email: 'E-mail',
        ledgersCreated: 'Registros Criados',
        totalAmount: 'Valor Total',
        yearToDateLabel: 'Ano até a Data'
      },

      admin: {
        title: 'Painel de Administração',
        subtitle: 'Gerenciar configurações do sistema e convites',
        invitations: 'Convites',
        entryTypes: 'Tipos de Entrada',
        languageSettings: 'Configurações de Idioma',
        currentLanguage: 'Idioma Atual',
        selectLanguage: 'Selecione seu idioma preferido',
        saveLanguage: 'Salvar Idioma',
        languageSaved: 'Preferência de idioma salva com sucesso',
        languageError: 'Erro ao salvar preferência de idioma'
      },

      invitations: {
        title: 'Gerenciar Convites',
        subtitle: 'Criar e gerenciar convites de usuários',
        sendInvitationTitle: 'Enviar Convite',
        emailPlaceholder: 'usuario@exemplo.com',
        sendInvitation: 'Enviar',
        sending: 'Enviando...',
        invitationSent: 'Convite enviado com sucesso',
        invitationError: 'Erro ao enviar convite',
        invitationCreated: 'Convite Criado!',
        invitationCreatedMessage: 'Convite enviado! Compartilhe este link:',
        loading: 'Carregando convites...',
        recentInvitations: 'Convites Recentes',
        noInvitations: 'Nenhum convite enviado ainda',
        createFirst: 'Crie seu primeiro convite para começar',
        pending: 'Pendente',
        accepted: 'Aceito',
        expired: 'Expirado',
        sent: 'Enviado',
        expiresAt: 'Expira em',
        expires: 'Expira',
        createdBy: 'Criado por',
        copyLink: 'Copiar Link',
        copied: 'Copiado!',
        linkCopied: 'Link copiado para a área de transferência',
        copyError: 'Erro ao copiar link',
        delete: 'Excluir',
        deleteInvitation: 'Excluir Convite',
        deleteInvitationMessage: 'Tem certeza de que deseja excluir este convite? Esta ação não pode ser desfeita.',
        deleteSuccess: 'Convite excluído com sucesso',
        deleteError: 'Erro ao excluir convite',
        invalidEmail: 'Por favor, insira um e-mail válido'
      },

      entryTypes: {
        title: 'Tipos de Entrada',
        managerTitle: 'Gerenciar Tipos de Entrada',
        subtitle: 'Configurar categorias de receitas e despesas',
        name: 'Nome',
        category: 'Categoria',
        actions: 'Ações',
        income: 'Receita',
        expense: 'Despesa',
        edit: 'Editar',
        delete: 'Excluir',
        addType: 'Adicionar Tipo',
        addNew: 'Adicionar Novo Tipo',
        namePlaceholder: 'Insira o nome do tipo de entrada',
        enterTypeName: 'Insira o nome do tipo de entrada',
        selectCategory: 'Selecionar categoria',
        save: 'Salvar',
        cancel: 'Cancelar',
        loading: 'Carregando tipos de entrada...',
        saved: 'Tipo de entrada salvo com sucesso',
        deleted: 'Tipo de entrada excluído com sucesso',
        error: 'Erro ao salvar tipo de entrada',
        cannotDelete: 'Este tipo de entrada não pode ser excluído',
        nameRequired: 'O nome do tipo de entrada é obrigatório',
        deleteConfirmation: 'Tem certeza de que deseja excluir este tipo de entrada? Isso afetará todos os Lançamentos que o utilizam.',
        aboutTitle: 'Sobre Tipos de Entrada',
        aboutDefault: 'Tipos de entrada padrão (Dízimo, Escola Sabatina, Caixa, Despesas) não podem ser excluídos',
        aboutCustom: 'Tipos de entrada personalizados aparecem automaticamente em todos os formulários de Lançamentos semanal',
        aboutDeletion: 'Excluir um tipo de entrada afetará todos os Lançamentos existentes que o utilizam',
        defaultTypes: {
          tithe: 'Dízimo',
          'Sabbath School': 'Escola Sabatina',
          fund: 'Caixa',
          expenses: 'Despesas'
        },
        names: {
          tithe: 'Dízimo',
          'Sabbath School': 'Escola Sabatina',
          fund: 'Caixa',
          expenses: 'Despesas'
        },
        badges: {
          default: 'Padrão',
          protected: 'Protegido'
        }
      },

      ledgerForm: {
        titleNew: 'Novo Lançamento Semanal',
        titleEdit: 'Editar Lançamento Semanal',
        weekDate: 'Data da Semana',
        date: 'Data',
        entries: 'Entradas',
        entryAmounts: 'Valores das Entradas',
        amount: 'Valor',
        notes: 'Notas',
        notesOptional: 'Notas (Opcional)',
        notesPlaceholder: 'Adicionar notas adicionais...',
        save: 'Salvar Lançamento',
        cancel: 'Cancelar',
        saving: 'Salvando...',
        totalIncome: 'Total de Receitas',
        totalExpense: 'Total de Despesas',
        totalExpenses: 'Total de Despesas',
        netTotal: 'Total Líquido',
        saved: 'Lançamento salvo com sucesso',
        error: 'Erro ao salvar Lançamento',
        dateRequired: 'Data é obrigatória',
        amountRequired: 'Todos os valores devem ser preenchidos',
        invalidAmount: 'Valor inválido'
      },

      login: {
        title: 'Bem-vindo',
        subtitle: 'Sistema de Tesouraria',
        email: 'E-mail',
        emailPlaceholder: 'seu@email.com',
        password: 'Senha',
        passwordPlaceholder: 'Digite sua senha',
        signIn: 'Entrar',
        signingIn: 'Entrando...',
        error: 'E-mail ou senha inválidos',
        emailRequired: 'E-mail é obrigatório',
        passwordRequired: 'Senha é obrigatória'
      },

      acceptInvitation: {
        title: 'Aceitar Convite',
        subtitle: 'Complete seu perfil para começar',
        fullName: 'Nome Completo',
        fullNamePlaceholder: 'Digite seu nome completo',
        email: 'E-mail',
        password: 'Senha',
        passwordPlaceholder: 'Criar uma senha segura',
        confirmPassword: 'Confirmar Senha',
        confirmPasswordPlaceholder: 'Digite a senha novamente',
        createAccount: 'Criar Conta',
        creating: 'Criando...',
        success: 'Conta criada com sucesso',
        error: 'Erro ao criar conta',
        invalidToken: 'Convite inválido ou expirado',
        fullNameRequired: 'Nome completo é obrigatório',
        passwordMismatch: 'As senhas não coincidem',
        passwordMinLength: 'A senha deve ter pelo menos 6 caracteres'
      },

      deleteModal: {
        title: 'Confirmar Exclusão',
        deleteWeeklyLedger: 'Excluir Lançamento Semanal',
        deleteWeeklyLedgerMessage: 'Tem certeza de que deseja excluir este Lançamento semanal? Todas as entradas associadas serão removidas permanentemente. Esta ação não pode ser desfeita.',
        message: 'Tem certeza de que deseja excluir este item? Esta ação não pode ser desfeita.',
        confirm: 'Excluir',
        cancel: 'Cancelar',
        deleting: 'Excluindo...'
      },

      common: {
        loading: 'Carregando...',
        save: 'Salvar',
        cancel: 'Cancelar',
        delete: 'Excluir',
        edit: 'Editar',
        close: 'Fechar',
        confirm: 'Confirmar',
        error: 'Erro',
        success: 'Sucesso',
        admin: 'Administrador',
        user: 'Usuário',
        search: 'Buscar',
        actions: 'Ações',
        status: 'Status',
        date: 'Data',
        email: 'E-mail',
        name: 'Nome',
        treasurySystem: 'Sistema de Tesouraria'
      }
    }
  },
  'en-US': {
    translation: {
      nav: {
        dashboard: 'Dashboard',
        ledger: 'Ledger',
        statement: 'Statement',
        reports: 'Reports',
        admin: 'Admin',
        signOut: 'Sign Out'
      },

      dashboard: {
        title: 'Dashboard',
        subtitle: 'Manage weekly treasury ledgers',
        newWeek: 'New Week',
        totalLedgers: 'Total Ledgers',
        totalAmount: 'Total Amount',
        averagePerWeek: 'Average per Week',
        searchPlaceholder: 'Search by date, user, or notes...',
        loading: 'Loading ledgers...',
        noLedgers: 'No ledgers found',
        noLedgersSubtext: 'Create your first weekly ledger to get started',
        netTotal: 'Net Total',
        edit: 'Edit',
        delete: 'Delete',
        income: 'Income',
        expense: 'Expense',
        totalIncome: 'Total Income',
        totalExpenses: 'Total Expenses',
        recentActivity: 'Recent Activity',
        last30DaysAvg: 'Last 30 Days Avg',
        balance: 'Balance',
        saldo: 'Saldo',
        tithe: 'Tithe',
        sabbathSchool: 'Sabbath School',
        fund: 'Fund',
        expenses: 'Expenses',
        incomeSources: 'Income Sources',
        expenseSources: 'Expense Sources',
        noIncome: 'No income recorded',
        noExpenses: 'No expenses recorded'
      },

      statement: {
        title: 'Statement',
        subtitle: 'View financial statement with date filters',
        currentBalance: 'Current Balance',
        incomeSources: 'Income Sources',
        expenseItems: 'Expenses',
        totalChurch: 'Total Church',
        lessTithe: 'Less: Tithe',
        lessSabbathSchool: 'Less: Sabbath School',
        startingBalance: 'Starting Balance',
        noIncome: 'No income recorded',
        noExpenses: 'No expenses recorded',
        dateRange: 'Date Range',
        startDate: 'Start Date',
        endDate: 'End Date',
        allTime: 'All Time',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        thisYear: 'This Year',
        lastYear: 'Last Year',
        showing: 'Showing',
        to: 'to',
        applyFilter: 'Apply Filter',
        clearFilter: 'Clear Filter'
      },

      reports: {
        title: 'Reports',
        subtitle: 'View and export treasury reports',
        weeklySummary: 'Weekly Summary',
        monthlySummary: 'Monthly Summary',
        yearToDate: 'Year to Date',
        entryComparison: 'Entry Comparison',
        userActivity: 'User Activity',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportCSV: 'Export CSV',
        exportPDF: 'Export PDF',
        loading: 'Loading report data...',
        noData: 'No data available for the selected date range',
        date: 'Date',
        user: 'User',
        total: 'Total',
        month: 'Month',
        period: 'Period',
        entryType: 'Entry Type',
        count: 'Count',
        average: 'Average',
        email: 'Email',
        ledgersCreated: 'Ledgers Created',
        totalAmount: 'Total Amount',
        yearToDateLabel: 'Year to Date'
      },

      admin: {
        title: 'Admin Panel',
        subtitle: 'Manage system settings and invitations',
        invitations: 'Invitations',
        entryTypes: 'Entry Types',
        languageSettings: 'Language Settings',
        currentLanguage: 'Current Language',
        selectLanguage: 'Select your preferred language',
        saveLanguage: 'Save Language',
        languageSaved: 'Language preference saved successfully',
        languageError: 'Error saving language preference'
      },

      invitations: {
        title: 'Manage Invitations',
        subtitle: 'Create and manage user invitations',
        sendInvitationTitle: 'Send Invitation',
        emailPlaceholder: 'user@example.com',
        sendInvitation: 'Send',
        sending: 'Sending...',
        invitationSent: 'Invitation sent successfully',
        invitationError: 'Error sending invitation',
        invitationCreated: 'Invitation Created!',
        invitationCreatedMessage: 'Invitation sent! Share this link:',
        loading: 'Loading invitations...',
        recentInvitations: 'Recent Invitations',
        noInvitations: 'No invitations sent yet',
        createFirst: 'Create your first invitation to get started',
        pending: 'Pending',
        accepted: 'Accepted',
        expired: 'Expired',
        sent: 'Sent',
        expiresAt: 'Expires at',
        expires: 'Expires',
        createdBy: 'Created by',
        copyLink: 'Copy Link',
        copied: 'Copied!',
        linkCopied: 'Link copied to clipboard',
        copyError: 'Error copying link',
        delete: 'Delete',
        deleteInvitation: 'Delete Invitation',
        deleteInvitationMessage: 'Are you sure you want to delete this invitation? This action cannot be undone.',
        deleteSuccess: 'Invitation deleted successfully',
        deleteError: 'Error deleting invitation',
        invalidEmail: 'Please enter a valid email'
      },

      entryTypes: {
        title: 'Entry Types',
        managerTitle: 'Manage Entry Types',
        subtitle: 'Configure income and expense categories',
        name: 'Name',
        category: 'Category',
        actions: 'Actions',
        income: 'Income',
        expense: 'Expense',
        edit: 'Edit',
        delete: 'Delete',
        addType: 'Add Type',
        addNew: 'Add New Type',
        namePlaceholder: 'Enter entry type name',
        enterTypeName: 'Enter entry type name',
        selectCategory: 'Select category',
        save: 'Save',
        cancel: 'Cancel',
        loading: 'Loading entry types...',
        saved: 'Entry type saved successfully',
        deleted: 'Entry type deleted successfully',
        error: 'Error saving entry type',
        cannotDelete: 'This entry type cannot be deleted',
        nameRequired: 'Entry type name is required',
        deleteConfirmation: 'Are you sure you want to delete this entry type? This will affect all ledgers using it.',
        aboutTitle: 'About Entry Types',
        aboutDefault: 'Default entry types (tithe, Sabbath School, fund, expenses) cannot be deleted',
        aboutCustom: 'Custom entry types appear automatically in all weekly ledger forms',
        aboutDeletion: 'Deleting an entry type will affect all existing ledgers using it',
        defaultTypes: {
          tithe: 'Tithe',
          'Sabbath School': 'Sabbath School',
          fund: 'Fund',
          expenses: 'Expenses'
        },
        badges: {
          default: 'Default',
          protected: 'Protected'
        }
      },

      ledgerForm: {
        titleNew: 'New Weekly Ledger',
        titleEdit: 'Edit Weekly Ledger',
        weekDate: 'Week Date',
        date: 'Date',
        entries: 'Entries',
        entryAmounts: 'Entry Amounts',
        amount: 'Amount',
        notes: 'Notes',
        notesOptional: 'Notes (Optional)',
        notesPlaceholder: 'Add any additional notes...',
        save: 'Save Ledger',
        cancel: 'Cancel',
        saving: 'Saving...',
        totalIncome: 'Total Income',
        totalExpense: 'Total Expense',
        totalExpenses: 'Total Expenses',
        netTotal: 'Net Total',
        saved: 'Ledger saved successfully',
        error: 'Error saving ledger',
        dateRequired: 'Date is required',
        amountRequired: 'All amounts must be filled',
        invalidAmount: 'Invalid amount'
      },

      login: {
        title: 'Welcome Back',
        subtitle: 'Treasury System',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        signIn: 'Sign In',
        signingIn: 'Signing in...',
        error: 'Invalid email or password',
        emailRequired: 'Email is required',
        passwordRequired: 'Password is required'
      },

      acceptInvitation: {
        title: 'Accept Invitation',
        subtitle: 'Complete your profile to get started',
        fullName: 'Full Name',
        fullNamePlaceholder: 'Enter your full name',
        email: 'Email',
        password: 'Password',
        passwordPlaceholder: 'Create a secure password',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Enter password again',
        createAccount: 'Create Account',
        creating: 'Creating...',
        success: 'Account created successfully',
        error: 'Error creating account',
        invalidToken: 'Invalid or expired invitation',
        fullNameRequired: 'Full name is required',
        passwordMismatch: 'Passwords do not match',
        passwordMinLength: 'Password must be at least 6 characters'
      },

      deleteModal: {
        title: 'Confirm Deletion',
        deleteWeeklyLedger: 'Delete Weekly Ledger',
        deleteWeeklyLedgerMessage: 'Are you sure you want to delete this weekly ledger? All associated entries will be permanently removed. This action cannot be undone.',
        message: 'Are you sure you want to delete this item? This action cannot be undone.',
        confirm: 'Delete',
        cancel: 'Cancel',
        deleting: 'Deleting...'
      },

      common: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        confirm: 'Confirm',
        error: 'Error',
        success: 'Success',
        admin: 'Admin',
        user: 'User',
        search: 'Search',
        actions: 'Actions',
        status: 'Status',
        date: 'Date',
        email: 'Email',
        name: 'Name',
        treasurySystem: 'Treasury System'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    lng: 'pt-BR',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
